import styled from 'styled-components';

const ReviewSchemaWrapper = styled.div`
  padding: 0;
`;

export default ReviewSchemaWrapper;
